import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import { IrrigationStatusDot } from '../IrrigationStatusDot/IrrigationStatusDot'

export const IrrigationActivityLabel = ({
  label,
  externalVendorNames = [],
  currentValueStatus,
  showPlanned = true,
}: {
  label: string
  externalVendorNames?: SharedTypes.IrrigationScheduler.EIrrigationVendorName[]
  currentValueStatus: TIrrigationDeviceStatus
  showPlanned?: boolean
}) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        padding: '2px',
        width: '100%',
        minWidth: 0,
        height: 'auto',
      }}
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          color: colors.midnight,
          fontWeight: showPlanned ? 'bold' : 'normal',
          fontSize: showPlanned ? '14px' : '16px',
        }}
      >
        <IrrigationStatusDot status={currentValueStatus} />
        <span css={{ flex: 1 }}>{label}</span>
        <ExternalVendorIcons externalVendorNames={externalVendorNames} size={24} />
      </div>
      {showPlanned && (
        <div>
          <div css={{ padding: '7px 0 0 5px', fontSize: '14px' }}>
            {translate.phrases.banyanApp('Applied')}
          </div>
          <div css={{ padding: '5px 0 0 5px', fontSize: '14px' }}>
            {translate.phrases.banyanApp('Scheduled')}
          </div>
        </div>
      )}
    </div>
  )
}
